module.exports = __webpack_public_path__ + "static/media/album.d7310d14.svg";